<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">  
      <!------------------------search---------------------->
      <el-form :inline="true" class="backborder1 demo-form-inline" ref="query" :model="query" size="small">
      	  <el-form-item style="width:10%">
              <el-select v-model="query.activetype" placeholder="活动类型" clearable filterable @change="selectactivetype">
              	  <el-option v-for="item in activetypelists" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item style="width:13%">
          	  <el-select v-model="query.type" placeholder="活动方式" clearable filterable>
              	  <el-option v-for="item in typelists" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item style="width:13%">
          	  <el-select v-model="query.range" placeholder="活动范围" clearable filterable>
              	  <el-option label="指定商品" value="1" v-if="query.activetype==1 || query.activetype==''"></el-option>
              	  <el-option label="指定品牌" value="3" v-if="query.activetype==2 || query.activetype==''"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item style="width:15%">
              <el-input placeholder="请输入关键字" v-model="query.key" @keyup.enter.native="getList" clearable></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
          </el-form-item>
          <el-form-item>
              <el-button type="danger" icon="el-icon-plus"  @click="addDialog" v-if="actionauth.mall_offers_add=='true'">新增活动</el-button>
			  <!--
			  <el-button type="warning" icon="el-icon-goods"  @click="addDialognew" v-if="actionauth.mall_offers_add=='true'">新人专区活动管理</el-button>
			  <el-button type="warning" icon="el-icon-goods"  @click="addDialogchange" v-if="actionauth.mall_offers_add=='true'">换购活动管理</el-button>
		  	  -->
		  </el-form-item>
		  <!--
		  <el-form-item>
			  <el-button type="warning" icon="el-icon-goods"  @click="addDialogspecial" v-if="actionauth.mall_offers_add=='true'">特卖活动管理</el-button>
		  	  <el-button type="warning" icon="el-icon-goods"  @click="addDialogcut" v-if="actionauth.mall_offers_add=='true'">秒杀活动管理</el-button>
			  <el-button type="danger" icon="el-icon-goods"  @click="addDialogpintuan" v-if="actionauth.mall_offers_add=='true'">团购活动（集采）管理</el-button>
			  <el-button type="primary" icon="el-icon-goods"  @click="addDialoginvitation" v-if="actionauth.mall_offers_add=='true'">邀请有理活动管理</el-button>
		  </el-form-item>
		  -->
	  </el-form>
      <!------------------------search end---------------------->
	  
	  <!------------------------活动信息列表----------------------->
	  <div class="backborder2" style="margin-top:10px">
	      <el-table :data="lists" v-loading="listLoading">
			  <el-table-column label="ID" width="90">
			  	  <template slot-scope="scope">
	          	  	  <div class="cz-mall-offers-lists-ID">{{scope.row.id}}</div>
	          	  </template>
			  </el-table-column>
			  <el-table-column label="活动信息" min-width="130">
			  	  <template slot-scope="scope">
					  <div class="cz-mall-offers-lists-out">
	          	  	  	  <div class="cz-mall-offers-lists-ID">{{scope.row.name}}</div>
						  <el-tooltip class="item" effect="dark" content="单品活动" placement="top" v-if="scope.row.activetype=='单品'">
					  	  <div class="cz-mall-offers-lists-label" v-if="scope.row.activetype=='单品'"><img src="../../assets/offers_dp.png" /></div>
					 	  </el-tooltip>
						  <el-tooltip class="item" effect="dark" content="品牌活动" placement="top" v-if="scope.row.activetype=='品牌'">
						  <div class="cz-mall-offers-lists-label" v-if="scope.row.activetype=='品牌'"><img src="../../assets/offers_pp.png" /></div>
					  	  </el-tooltip>
						  <el-tooltip class="item" effect="dark" content="混拼活动" placement="top" v-if="scope.row.activetype=='混拼'">
						  <div class="cz-mall-offers-lists-label" v-if="scope.row.activetype=='混拼'"><img src="../../assets/offers_hh.png" /></div>
	          	  	  	  </el-tooltip>
						  
						  <div class="cz-mall-offers-lists-status-1" v-if="scope.row.status=='未开始'">未开始</div>
						  <div class="cz-mall-offers-lists-status-2" v-if="scope.row.status=='进行中'">进行中...</div>
						  <div class="cz-mall-offers-lists-status-1" v-if="scope.row.status=='已结束'">已结束</div>
					  </div>
				  </template>
			  </el-table-column>

			  <el-table-column label="活动方式" width="240" align="center">
			  	  <template slot-scope="scope">
					  <div class="cz-mall-offers-lists-ID">{{scope.row.types}}</div>
					  <div class="cz-mall-offers-lists-gift">（默认：{{scope.row.defaults}}）</div>
				  </template>
			  </el-table-column>

			  <el-table-column label="活动范围" width="170" align="center">
			  	  <template slot-scope="scope">
					  <el-button type="mini" round @click="checkactivearea(scope.row)">{{scope.row.range=='指定商品' ? '查看商品、赠品' : '查看品牌、赠品'}}</el-button>
				  </template>
			  </el-table-column>

			  <el-table-column label="活动时间" width="160" align="center">
			  	  <template slot-scope="scope">
					  <div class="cz-mall-offers-lists-ID">{{scope.row.inputtime}}</div>
				  </template>
			  </el-table-column>
	          
	          <el-table-column label="操作" width="210" align="center">
		          <template slot-scope="scope">
		            <el-button type="warning" size="small" round @click="editCurrent(scope.row)" v-if="actionauth.mall_offers_edit=='true'">编辑</el-button>
		            <el-button type="" size="small"  round @click="delCurrent(scope.row)" v-if="actionauth.mall_offers_del=='true'">删除</el-button>
		          </template>
	          </el-table-column>
	      </el-table>
	      <div class="block">
		      <!--分页begin-->
		      <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange"
		      	  :current-page="query.p"
		          :page-sizes="[10, 20, 50]"
		          :page-size="query.rollpage"
		          layout="total, sizes, prev, pager, next, jumper"
		          :total="total_rows">
		      </el-pagination>
		      <!--分页end-->
	      </div>
      </div>


	  <!-- 查看活动商品信息 -->
	  <el-dialog title="查看活动商品/品牌信息" :visible.sync="activeareaDialog" width="40%" top="10vh">
		  <div class="cz-mall-offers-lists-goods-show" v-loading="activearealoading">

		  	  <!-- 商品/品牌 -->
			  <div class="cz-mall-offers-lists-badge">
			  <el-radio-group v-model="activeareainfos.tag" size="small" style="margin-bottom:10px">
			  	  <el-badge :value="activeareainfos.lists.length > 0 ? activeareainfos.lists.length : ''" class="item">
      			  <el-radio-button label="1" >查看商品/品牌</el-radio-button>
				  </el-badge>
				  <el-badge :value="activeareainfos.gifts.length > 0 ? activeareainfos.gifts.length : ''" class="item">
				  <el-radio-button label="2" >查看赠品</el-radio-button>
				  </el-badge>
    		  </el-radio-group>
			  </div>

			  <div v-if="activeareainfos.tag==1">
		  	  <div class="cz-mall-offers-lists-goods-brands" v-for="(item,index) in activeareainfos.lists" :key="index">
				  <div class="cz-mall-offers-lists-goods-main">
				  	  <div class="cz-mall-offers-lists-goods-main-out"><img :src="item.thumb=='' ? require('../../assets/default_img_mini.png') : item.thumb"></div>
				  	  <div class="cz-mall-offers-lists-goods-main-name">{{item.name}}</div>
					  <div class="cz-mall-offers-lists-goods-main-ID">ID：{{item.id}}</div>
				  </div>
				  <div class="cz-mall-offers-lists-goods-uad">
                      <i class="uad-sys-offers-details-brand-grant-no" v-if="item.brandtype==1">未授权</i>
					  <i class="uad-sys-offers-details-brand-grant-yes" v-if="item.brandtype==2">已授权</i>
					  <i class="uad-sys-offers-details-brand-grant-no" v-if="item.brandtype==3">授权失败</i>
					  <i class="uad-sys-offers-details-brand-grant-no" v-if="item.brandtype==4">授权未开始</i>
					  <i class="uad-sys-offers-details-brand-grant-no" v-if="item.brandtype==5">授权到期</i>
				  </div>
				  <div class="cz-mall-offers-lists-goods-uad" v-if="activeareainfos.type=='goods'">
                      <i class="uad-sys-offers-details-brand-grant-yes" v-if="item.isgrounding==0">已上架</i>
					  <i class="uad-sys-offers-details-brand-grant-no" v-if="item.isgrounding==1">已下架</i>
				  </div>
			  </div>
			  </div>

			  <div v-if="activeareainfos.tag==2">
		  	  <div class="cz-mall-offers-lists-goods-brands" v-if="activeareainfos.gifts.length > 0" v-for="(item,index) in activeareainfos.gifts" :key="index">
				  <div class="cz-mall-offers-lists-goods-main">
				  	  <div class="cz-mall-offers-lists-goods-main-out"><img :src="item.thumb=='' ? require('../../assets/default_img_mini.png') : item.thumb"></div>
				  	  <div class="cz-mall-offers-lists-goods-main-name">{{item.name}}</div>
					  <div class="cz-mall-offers-lists-goods-main-ID">ID：{{item.id}}</div>
				  </div>
				  <div class="cz-mall-offers-lists-goods-uad">
                      <i class="uad-sys-offers-details-brand-grant-no" v-if="item.brandtype==1">未授权</i>
					  <i class="uad-sys-offers-details-brand-grant-yes" v-if="item.brandtype==2">已授权</i>
					  <i class="uad-sys-offers-details-brand-grant-no" v-if="item.brandtype==3">授权失败</i>
					  <i class="uad-sys-offers-details-brand-grant-no" v-if="item.brandtype==4">授权未开始</i>
					  <i class="uad-sys-offers-details-brand-grant-no" v-if="item.brandtype==5">授权到期</i>
				  </div>
				  <div class="cz-mall-offers-lists-goods-uad">
                      <i class="uad-sys-offers-details-brand-grant-yes" v-if="item.isgrounding==0">已上架</i>
					  <i class="uad-sys-offers-details-brand-grant-no" v-if="item.isgrounding==1">已下架</i>
				  </div>
			  </div>
			  <div class="cz-mall-offers-lists-goods-brands-no" v-if="!activeareainfos.gifts || activeareainfos.gifts.length==0">
			  	  <img src="../../assets/offers_gifts.png" />
				  <span>没有添加赠品</span>
			  </div>
			  </div>


		  </div>
	  </el-dialog>

           
  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
        url:this.GLOBAL.domain+"Offers/index",
        transitionshow:true,
        actionauth:'', //功能权限
        activetypelists:[{id:'1',name:'单品'},{id:'2',name:'品牌'},{id:'3',name:'混拼'}],
        selectgobtype:'',
        selectgoblargess:'',
        typelists:[],
        categorylist:[],
        brandlists:[],
        lists:[],
        total_rows: 0,
        listLoading:false,
        query:{
	        act:'lists',
	        token:this.$cookies.get('token'),
	        activetype:'',
	        type:'',
	        range:'',
	        key:'',
	        rollpage: 10, // 页大小
	        p: 1
        },
      
        createDialog:false,
        addcreateLoading:false,
        create: {
        	act:'add',
	        token:this.$cookies.get('token'),
	        name:'',
	        validity:'',
	        activetype:'1',
	        type:'1',
	        range:'1',
	        is_add:'0',
	        param:[],
	        mjjj:[],
	        mjss:[],
	        mnss:[],
	        msdz:[],
	        mjdz:[],
	        mjsj:[],
	        msgoods:[],
	        mngoods:[],
        },
        
        updateDialog:false,
        addupdateLoading:false,
        update: {
        	act:'edit',
	        token:this.$cookies.get('token'),
	        id:'',
	        name:'',
	        validity:'',
	        activetype:1,
	        type:'1',
	        range:'1',
	        is_add:'0',
	        param:[],
	        mjjj:[],
	        mjss:[],
	        mnss:[],
	        msdz:[],
	        mjdz:[],
	        mjsj:[],
	        msgoods:[],
	        mngoods:[],
        },
        
        isnewselect:false,
        goodsbrandDialog:false,
        goodsbrandLoading:false,
        goodsbrandlists:[],
        goodsandbrand_total_rows:0,
        pclickstatus:[],
        multipleSelection:[],
        goodsbrand: {
        	act:'selectgoodsorbrand',
        	token:this.$cookies.get('token'),
        	activetype:'',
        	type:'',
        	at:'',
        	ids:'',
        	catid:'',
        	brandid:'',
        	key:'',
        	p:1,
        	rollpage:10
        },
        openlists:[],
		ismoreapplyaccess:false,
		activeareaDialog:false,
		activearealoading:false,
		activeareainfos: {
			type:'',
			tag:0,
			lists:[],
			gifts:[],
		},
        
    }
  },
  
  mounted(){
    this.getactionauth();
    this.getList();
    this.gettypelists();
    this.getBrand(); //获取品牌信息
	this.getCategoryList(); //获取分类信息
	this.getmoreapplyaccess(); //获取供应商多个商品权限
  },
  
  methods:{

    /** 查看商品、品牌范围 **/
	checkactivearea(item) {
		this.activeareaDialog=true;
		this.activearealoading=true;
		this.activeareainfos={tag:1,type:item.activetype=='品牌' ? 'brand' : 'goods',lists:[],gifts:[]};

		var resource = this.$resource(this.url);
        resource.save({ act:'getoffersgoodsandgifts',token:this.$cookies.get('token'),id:item.id}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
				this.activearealoading=false;
            }else{
                var result = JSON.parse(Base64.decode(res.data.Data));
				this.activeareainfos.lists=result.lists;
				this.activeareainfos.gifts=result.gifts;
				this.activearealoading=false;
            }
        }).catch((res) => {
            this.activearealoading=false; 
        });

	},

  
    /** 重置表单 **/
    reset() {
        this.$refs.create.resetFields();
    },
  
  	/** 获取功能权限 **/
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },

	//获取是否允许使用添加多个供应商权限
	getmoreapplyaccess() {
		var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
        resource.save({ act:'getmoreapplyaccess',token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                var result = JSON.parse(Base64.decode(res.data.Data));
				result.isaccessapplytype==1 ? this.ismoreapplyaccess : this.ismoreapplyaccess=true;
            }
        }).catch((res) => {
              	  
        });
	},
    
    /** 获取产品分类 **/
    getCategoryList() {
    	var resource = this.$resource(this.GLOBAL.domain+"Product/index");
        resource.query({ act:'getmallcatelist',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.categorylist = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 获取品牌 **/
    getBrand(){
        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
        resource.query({act:'getsyslists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.brandlists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    
    /** 修改活动类型 **/
    selectactivetype() {
    	this.query.range='';
    },
    
    /** 获取活动方式信息 **/
    gettypelists() {
    	var resource = this.$resource(this.url);
        resource.query({act:'gettype',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.typelists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 信息列表 **/
    getList(){
        this.listLoading = true;
        var resource = this.$resource(this.url);
        resource.query(this.query).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.listLoading = false;
	        }else{
	        	var _this=this;
				this.openlists=[];
	            this.lists = JSON.parse(Base64.decode(res.data.Data));
				_this.lists.forEach(function(item,i) {
	            	item.isopen==1 ? _this.openlists.push(true) : _this.openlists.push(false);
	            });	          
	            this.total_rows=parseInt(res.data.count);
	            this.listLoading = false;
	        }
        }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
        });
    },
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },
    
    /** 新增活动信息 **/
    addDialog() {
    	this.$emit('listenchild',{name:'新增促销活动',url:'Offersactiveadd'});
    },

	/** 跳转新人专区活动管理 **/
	addDialognew() {
		this.$emit('listenchild',{name:'新人专区活动管理',url:'Offersnew'});
	},

	/** 跳转换购专区活动管理 **/
	addDialogchange() {
		this.$emit('listenchild',{name:'换购活动管理',url:'Offerschange'});
	},

	/** 跳转特卖活动专区管理 **/
	addDialogspecial() {
		this.$emit('listenchild',{name:'特卖活动管理',url:'Offersspecial1'});
		//this.$emit('listenchild',{name:'特卖活动管理',url:'Offersspecial2'});
	},

	/** 秒杀活动专区管理 **/
	addDialogcut() {
		this.$emit('listenchild',{name:'秒杀活动管理',url:'Offerscut'});
	},

	/** 拼团活动专区管理 **/
	addDialogpintuan() {
		this.$emit('listenchild',{name:'拼团活动管理',url:'Offerspintuan'});
	},

	/** 邀请有礼活动专区管理 **/
	addDialoginvitation() {
		this.$emit('listenchild',{name:'邀请有礼活动管理',url:'Offersinvitation'});
	},

    
    /** 切换活动类型修改活动范围 **/
    changeaddactivetype(type) {
    	this.$confirm('切换活动类型会将该类型下添加的商品或品牌删除，您是否需要切换？', { type: 'warning' }).then(() => {
        	if(type=='create') {
    			this.create.range='';
    			this.create.param=[];
	    	}else {
	    		this.update.range='';
	    		this.update.param=[];
	    	}      
        }).catch(() => {
            if(type=='create') {
    			this.create.activetype=='1' ? this.create.activetype='2' : this.create.activetype='1';    			
	    	}else {
	    		this.update.activetype=='1' ? this.update.activetype='2' : this.update.activetype='1';
	    	} 
        });    	
    },
    
    /** 删除已添加的商品/品牌输入框 **/
    delAddProject(index,type) {
    	if(type=='create') {
    		this.create.param.splice(index,1);
    	}else {
    		this.update.param.splice(index,1);
    	}
    },
    
    /** 选择商品/品牌信息 **/
    selectgap(type) {
     	this.selectgobtype=type;
     	this.selectgoblargess='';
        this.goodsbrand.activetype= type=='create' ? this.create.activetype : this.update.activetype;
        this.goodsbrand.type=type;
        this.goodsbrand.ids=[];
        this.goodsbrand.catid=[];
        this.goodsbrand.brandid='';
        this.goodsbrand.key='';
        this.goodsbrand.warehouseid='';
        this.goodsbrand.p=1;
        this.goodsbrand.rollpage=10;
        var _this=this;
        
        if(type=='create') {        	
        	this.create.param.forEach(function(e,i) {
        		if(e.id > 0) _this.goodsbrand.ids.push(e.id);
        	});
        }else{
        	this.update.param.forEach(function(e,i) {
        		if(e.id > 0) _this.goodsbrand.ids.push(e.id);
        	});
        }
		
		this.goodsbrandDialog=true;
		this.getgoodsorbrand();        
    },
    
    /** 获取商品或品牌信息列表 **/
    getgoodsorbrand() {
    	if(this.isnewselect==true) {
    		this.goodsbrand.p=1;
    		this.goodsbrand.rollpage=10;
    	}
    
    	this.goodsbrandLoading=true;
    	this.pclickstatus=[]; //重新设置商品/品牌状态
    	this.multipleSelection=[]; //重新设置已选中的商品/品牌
        var resource = this.$resource(this.url);
        resource.save(this.goodsbrand).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.goodsbrandLoading=false;
	        }else{
	        	var _this=this;
	            this.goodsbrandlists = JSON.parse(Base64.decode(res.data.Data));
	            this.goodsandbrand_total_rows=parseInt(res.data.count);
	            //设置单行信息状态为未选择
	            this.goodsbrandlists.forEach(function(e,index) {_this.pclickstatus[index]=0;});
	            this.goodsbrandLoading=false;
	            if(this.isnewselect==true) this.isnewselect=false;
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
            this.goodsbrandLoading=false;
        });
    },
    gobpageSizeChange(val) {
        this.goodsbrand.rollpage = val;
        this.getgoodsorbrand();
    },
    gobpageCurrentChange(val) {
        this.goodsbrand.p = val;
        this.getgoodsorbrand();
    },
    
    
    /** 点击单行触发选择商品/品牌 **/
    selectrow(row,event,column) {
    	var _this=this;
    	var id=row.id;
    	var number=0;
    	var isselect=0;
    	
    	//获取当前商品在商品列表里的位置
    	this.goodsbrandlists.forEach(function(e,index) {if(id==e.id) number=index;});
    	//给该位置进行勾选或取消勾选
    	this.pclickstatus[number]==0 ? this.pclickstatus[number]=1 : this.pclickstatus[number]=0;
		//判断该商品在选取列表里是否存在，存在则删除该商品，不存在则添加该商品
		this.$refs.multipleTable.toggleRowSelection(this.goodsbrandlists[number]);
		
		//判断商品或品牌是否已经选择
		this.multipleSelection.forEach(function(e,index) {if(id==e.id) isselect=1;});
		
		if(isselect==1) { //删除已添加的商品/品牌
			this.multipleSelection.forEach(function(e,index) {
				if(id==e.id) _this.multipleSelection.splice(index,1);
			});
		}else {	//添加选中的商品/品牌
			this.multipleSelection.push(row);	
		}
    },
    
    /** 点击每行前面的选择框勾选/取消勾选商品 **/
    handleSelectsingle(val,row) {    
    	var _this=this;
    	var id=row.id;
    	var number=0;
    	var isselect=0;
    	
    	//获取当前商品在商品列表里的位置
    	this.goodsbrandlists.forEach(function(e,index) {if(id==e.id) number=index;});
    	//给该位置进行勾选或取消勾选
    	this.pclickstatus[number]==0 ? this.pclickstatus[number]=1 : this.pclickstatus[number]=0;
		//判断该商品在选取列表里是否存在，存在则删除该商品，不存在则添加该商品
		this.multipleSelection.forEach(function(e,index) {if(id==e.id) isselect=1;});
		
    	if(isselect==1) { //删除已添加的商品/品牌
			this.multipleSelection.forEach(function(e,index) {
				if(id==e.id) _this.multipleSelection.splice(index,1);
			});
		}else {	//添加选中的商品/品牌
			this.multipleSelection.push(row);	
		}
    },
    
    /** 点击选全部可见商品 **/
    handleSelectall(val) {     	    	
    	var _this=this;  	
    	this.multipleSelection=[];
    	
    	val.forEach(function(e,index) {_this.multipleSelection.push(e);});
    	this.pclickstatus.forEach(function(e,index) {
    		val=='' ? _this.pclickstatus[index]=0 : _this.pclickstatus[index]=1;
    	});
    },
    
    /** 选择需要添加的商品或品牌 **/
    ensuregob() {
    	var _this=this;
    	var type=this.selectgobtype;  //类型（新增、更新）
    	var at=this.selectgoblargess; //是否是赠送商品
        if(this.multipleSelection.length==0) {this.$message.error("请选择要添加的商品或品牌");return false;}
        this.multipleSelection.forEach(function(e,index) {
        	if(type=='create') {
        		at=='' ? _this.create.param.push(e) : '';
        		at=='msgoods' ? _this.create.msgoods.push(e) : '';
        		at=='mngoods' ? _this.create.mngoods.push(e) : '';
        	}else {
        		at=='' ? _this.update.param.push(e) : '';
        		at=='msgoods' ? _this.update.msgoods.push(e) : '';
        		at=='mngoods' ? _this.update.mngoods.push(e) : '';
        	}

        });
        this.goodsbrandDialog=false;
    },
    
    /** 增加满金额减金额活动层级数 **/
    addmjjj(type) {
    	if(type=='create') {
    		if(this.create.mjjj.length==5) {this.$message.error("满金额减金额最多只能添加5个活动层级");return false;}
    		this.create.mjjj.push({buy:'',derate:'',addmoney:0});	
    	}else {
    		if(this.update.mjjj.length==5) {this.$message.error("满金额减金额最多只能添加5个活动层级");return false;}
    		this.update.mjjj.push({buy:'',derate:'',addmoney:0});	
    	}
    },
    
    /** 减少满金额减金额活动层级数 **/ 
    delmjjj(index,type) {
    	if(type=='create') {
    		this.create.mjjj.splice(index,1);
    	}else {
    		this.update.mjjj.splice(index,1);
    	}
    }, 
    
    /** 添加满金额送商品活动层级 **/
    mjss(type) {
    	if(type=='create') {
    		if(this.create.mjss.length==5) {this.$message.error("满金额送商品最多只能添加5个活动层级");return false;}
    		this.create.mjss.push({buy:'',derate:0,addmoney:0});
    	}else {
    		if(this.update.mjss.length==5) {this.$message.error("满金额送商品最多只能添加5个活动层级");return false;}
    		this.update.mjss.push({buy:'',derate:0,addmoney:0});
    	}
    },
    
    /** 删除满金额送商品活动层级 **/
    delmjss(index,type) {
    	if(type=='create') {
    		this.create.mjss.splice(index,1);
    	}else {
    		this.update.mjss.splice(index,1);
    	}
    },
    
    /** 添加满金额送商品信息 **/	
    addmjss(type) {
    	this.selectgobtype=type;
     	this.selectgoblargess='msgoods';
        this.goodsbrand.activetype='1'; //单品
        this.goodsbrand.type=type;
        this.goodsbrand.ids=[];
        this.goodsbrand.catid=[];
        this.goodsbrand.brandid='';
        this.goodsbrand.key='';
        this.goodsbrand.warehouseid='';
        this.goodsbrand.p=1;
        this.goodsbrand.rollpage=10;
        var _this=this;
        
        if(type=='create') {        	
        	this.create.msgoods.forEach(function(e,i) {
        		if(e.id > 0) _this.goodsbrand.ids.push(e.id);
        	});
        }else {
        	this.update.msgoods.forEach(function(e,i) {
        		if(e.id > 0) _this.goodsbrand.ids.push(e.id);
        	});
        }
		
		this.goodsbrandDialog=true;
		this.getgoodsorbrand();
    },
    
    /** 删除满金额送商品条数 **/
    delmjsslarger(index,type) {
    	if(type=='create') {
    		this.create.msgoods.splice(index,1);
    	}else {
    		this.update.msgoods.splice(index,1);
    	}
    },
    
    /** 添加满数量送商品活动层级 **/
    addmnss(type) {
    	if(type=='create') {
    		if(this.create.mnss.length==5) {this.$message.error("满数量送商品最多只能添加5个活动层级");return false;}
    		this.create.mnss.push({buy:'',derate:0,addmoney:0});
    	}else {
    		if(this.update.mnss.length==5) {this.$message.error("满金额送商品最多只能添加5个活动层级");return false;}
    		this.update.mnss.push({buy:'',derate:0,addmoney:0});
    	}
    },
    
    /** 减少满数量送商品活动层级数 **/ 
    delmnss(index,type) {
    	if(type=='create') {
    		this.create.mnss.splice(index,1);
    	}else {
    		this.update.mnss.splice(index,1);
    	}
    },
    
    /** 添加满金额送商品信息 **/	
    addmngoods(type) {
    	this.selectgobtype=type;
     	this.selectgoblargess='mngoods';
        this.goodsbrand.activetype='1'; //单品
        this.goodsbrand.type=type;
        this.goodsbrand.ids=[];
        this.goodsbrand.catid=[];
        this.goodsbrand.brandid='';
        this.goodsbrand.key='';
        this.goodsbrand.warehouseid='';
        this.goodsbrand.p=1;
        this.goodsbrand.rollpage=10;
        var _this=this;
        
        if(type=='create') {        	
        	this.create.mngoods.forEach(function(e,i) {
        		if(e.id > 0) _this.goodsbrand.ids.push(e.id);
        	});
        }else {
        	this.update.mngoods.forEach(function(e,i) {
        		if(e.id > 0) _this.goodsbrand.ids.push(e.id);
        	});
        }
		
		this.goodsbrandDialog=true;
		this.getgoodsorbrand();
    }, 
    
    /** 删除满数量送商品条数 **/
    delmnsslarger(index,type) {
    	if(type=='create') {
    		this.create.mngoods.splice(index,1);
    	}else {
    		this.update.mngoods.splice(index,1);
    	}
    },
    
    /** 新增满数量打折层级 **/
    addmsdz(type) {
    	if(type=='create') {
    		if(this.create.msdz.length==5) {this.$message.error("满数量打折最多只能添加5个活动层级");return false;}
    		this.create.msdz.push({buy:'',derate:'',addmoney:0});
    	}else {
    		if(this.update.msdz.length==5) {this.$message.error("满数量打折最多只能添加5个活动层级");return false;}
    		this.update.msdz.push({buy:'',derate:'',addmoney:0});
    	}
    },
    
    /** 删除满数量打折层级 **/
    delmsdz(index,type) {
    	if(type=='create') {
    		this.create.msdz.splice(index,1);
    	}else {
    		this.update.msdz.splice(index,1);
    	}
    },
    
    /** 新增满金额打折层级 **/
    addmjdz(type) {
    	if(type=='create') {
    		this.create.mjdz.push({buy:'',derate:'',addmoney:0});
    	}else {
    		this.update.mjdz.push({buy:'',derate:'',addmoney:0});
    	}
    },
    
    /** 删除满金额打折层级 **/
    delmjdz(index,type) {
    	if(type=='create') {
    		this.create.mjdz.splice(index,1);
    	}else {
    		this.update.mjdz.splice(index,1);
    	}
    },
    
    /** 新增满金额送金额层级 **/
    addmjsj(type) {
    	if(type=='create') {
    		this.create.mjsj.push({buy:'',derate:'',addmoney:0});
    	}else {
    		this.update.mjsj.push({buy:'',derate:'',addmoney:0});
    	}
    },
    
    /** 删除满金额打折层级 **/
    delmjsj(index,type) {
    	if(type=='create') {
    		this.create.mjsj.splice(index,1);
    	}else {
    		this.update.mjsj.splice(index,1);
    	}
    },
    
    
    /** 保存新增活动 **/
    addcreateSave() {    
    	this.addcreateLoading=true;
    	var resource = this.$resource(this.url);
        resource.save(this.create).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.addcreateLoading=false;
	        }else{
	        	this.$message.success('添加活动信息成功！');
	            this.addcreateLoading=false;
	            this.createDialog=false;
	            this.getList();
	        }
        }).catch((res) => {
            this.addcreateLoading=false;
        });
    },
    
    /** 删除活动信息 **/
    delCurrent(item) {
    	this.$confirm('您是否要删除该活动，继续?', '提示', { type: 'warning' }).then(() => {    	
        	// 向请求服务端删除
            var resource = this.$resource(this.url);
            resource.save({act:'del',id:item.id,token:this.$cookies.get('token')}).then((res) => {
            	if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                }else{                
                    this.$message.success('解挂成功!');
                    this.getList();
                }
            }).catch((res) => {
            	//this.$message.error(this.GLOBAL.errortext);
            });
        }).catch(() => {
            this.$message.info('已取消操作!');
        });
    },
    
    /** 获取活动信息 **/
    editCurrent(item) {
    	this.$emit('listenchild',{name:'编辑促销活动',url:'Offersactiveedit',data:item});
    	//重置活动信息
    	/**
    	this.selectgobtype='update';
    	this.update.id='';
    	this.update.name='';
	    this.update.validity=[];
	    this.update.activetype=1;
	    this.update.is_add='0';
	    this.update.type='';
	    this.update.range='';
	    this.update.param=[];
	    this.update.mjjj=[];
	    this.update.mjss=[];
	    this.update.mnss=[];
	    this.update.msdz=[];
	    this.update.mjdz=[];
	    this.update.mjsj=[];
	    this.update.msgoods=[];
	    this.update.mngoods=[];
	    
	    var resource = this.$resource(this.url);
        resource.save({act:'getinfo',id:item.id,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{   
            	var _this=this;    
            	var result=JSON.parse(Base64.decode(res.data.Data));  
            	this.update.id=result.id;
            	this.update.name=result.name;
            	this.update.validity=result.validity;
            	this.update.is_add=result.is_add;
			    this.update.activetype=result.activetype;
			    this.update.type=result.type;
			    this.update.range=result.range;
			    this.update.param=result.param;
			    
			    if(result.type==1) { //满金额减金额
			    	result.mjjj.forEach(function(e,index) {
			    		_this.update.mjjj.push(e);
			    	});
			    
			    }else if(result.type==2) { //满金额送商品
			    	result.mjss.forEach(function(e,index) {
			    		_this.update.mjss.push(e);
			    	});
			    	result.msgoods.forEach(function(e,index) {
			    		_this.update.msgoods.push(e);
			    	});
			    	
			    }else if(result.type==3) { //满数量送商品
			    	result.mnss.forEach(function(e,index) {
			    		_this.update.mnss.push(e);
			    	});
			    	result.mngoods.forEach(function(e,index) {
			    		_this.update.mngoods.push(e);
			    	});
			    	
			    }else if(result.type==4) { //满数量打折
			    	result.msdz.forEach(function(e,index) {
			    		_this.update.msdz.push(e);
			    	});
			    	
			    }else if(result.type==5) { //满金额打折
			    	result.mjdz.forEach(function(e,index) {
			    		_this.update.mjdz.push(e);
			    	});
			    
			    }else if(result.type==6) { //满金额送金额
			    	result.mjsj.forEach(function(e,index) {
			    		_this.update.mjsj.push(e);
			    	});
			    	
			    }
            	
            	this.updateDialog=true;
            }
        }).catch((res) => {
        	//this.$message.error(this.GLOBAL.errortext);
        });
        */
    },
    
    /** 保存编辑活动信息 **/
    addupdateSave() {
    	this.addupdateLoading=true;
    	var resource = this.$resource(this.url);
        resource.save(this.update).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.addupdateLoading=false;
            }else{                
            	this.$message.success('修改活动信息成功!');
                this.getList();
                this.addupdateLoading=false;
                this.updateDialog=false;
            }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
            this.addupdateLoading=false;
        });
    },
    
    //开启、关闭
    openandclose(index,item) {
    	var isopen=0;
    	this.openlists[index] ? isopen=1 : isopen=0;
    	var resource = this.$resource(this.url);
        resource.save({act:'openandclose',id:item.id,isopen:isopen,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{   
            	
            }
        }).catch((res) => {
        	
        });
    	
    },
    
     
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.cz-mall-offers-lists-ID {font-size:13px;line-height:21px;display:inline-block;}
.cz-mall-offers-lists-out {display:flex;width:100%;align-items:center;}
.cz-mall-offers-lists-label {display:inline-block;width:16px;height:16px;margin-left:5px;}
.cz-mall-offers-lists-label img {width:16px;height:16px;margin-left:5px;}
.cz-mall-offers-lists-status-1 {display:inline-block;font-size:12px;line-height:12px;margin-left:15px;background:rgba(221,221,221,.3);border:1px solid rgba(221,221,221,.7);border-radius:6px;color:#909399;padding:3px 10px;}
.cz-mall-offers-lists-status-2 {display:inline-block;font-size:12px;line-height:12px;margin-left:15px;background:rgba(103,194,58,.1);border:1px solid rgba(103,194,58,.2);border-radius:6px;color:#67c23a;padding:3px 10px;}
.cz-mall-offers-lists-gift {font-size:12px;line-height:23px;color:#999999;}
.cz-mall-offers-lists-goods-show {display:inline-block;width:100%}
.cz-mall-offers-lists-goods-brands {display:inline-block;width:100%;padding:15px 0;border-bottom:1px solid #DCDFE6}
.cz-mall-offers-lists-goods-main {float:left;width:calc(55% - 10px);height:60px;padding:0 10px 0 0;}
.cz-mall-offers-lists-goods-main-out {float:left;display:flex;justify-content:center;align-items:center;width:60px;height:60px;background:rgba(221,221,221,.3);border:1px solid rgba(221,221,221,.7);border-radius:6px;}
.cz-mall-offers-lists-goods-main-out img {max-width:85%;max-height:85%;border-radius:6px;}
.cz-mall-offers-lists-goods-main-name {float:left;display:flex;align-items:center;margin-left:15px;width:calc(100% - 60px - 2px - 15px);font-size:13px;line-height:21px;}
.cz-mall-offers-lists-goods-main-ID {float:left;display:flex;align-items:center;margin-left:15px;width:calc(100% - 60px - 2px - 15px);font-size:12px;line-height:21px;color:#999999;}
.cz-mall-offers-lists-goods-uad {float:left;width:20%;height:60px;display:flex;justify-content:center;align-items:center;}
.uad-sys-offers-details-brand-grant-no {font-size:12px;color:#fff;background:#909399;line-height:12px;padding:3px 0;border-radius:15px;font-style:normal;text-align:center;margin-top:5px;padding:3px 10px}
.uad-sys-offers-details-brand-grant-yes {font-size:12px;color:#fff;background:#67C23A;line-height:12px;padding:3px 0;border-radius:15px;font-style:normal;text-align:center;margin-top:5px;padding:3px 10px}
.cz-mall-offers-lists-badge .el-badge__content.is-fixed {z-index:5;}

.cz-mall-offers-lists-goods-brands-no {display:flex;width:100%;height:150px;justify-content:center;align-items:center;}
.cz-mall-offers-lists-goods-brands-no img {width:25px;height:25px;}
.cz-mall-offers-lists-goods-brands-no span {font-size:14px;line-height:23px;margin-left:2%;color:#999999}
</style>


// WEBPACK FOOTER //
// src/components/mall/Offers.vue